import React, { Component } from 'react';
import ModalUpdateDailyTask from './components/ModalUpdateDailyTask';

import '../../assets/css/giftmanager.css';
import $ from 'jquery';
import { toast } from 'react-toastify';

import { listDailyTasks } from './api';
import { DAILY_TASK_GROUPS, TASK_TYPES, TASK_RANKS } from './constants';

const EMPTY_TASK = {
    id: "",
    name: "",
    group: "",
    image: "",
    // Số: backend yêu cầu @NotNull cho requestNumber/bonus → mặc định 0
    // để Jackson không phải parse chuỗi rỗng.
    requestNumber: 0,
    bonus: 0,
    type: "",
    rank: "",
    screenId: "",
    minLevel: 0,
};

export default class DailyTaskPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dailyTasks: [],
            originalDailyTasks: [],
            selectGroup: '',
            selectType: '',
            selectRank: '',
            nameSearch: '',
            register: true,
            dailyTask: null,
            loading: false,
        };

        this.getDailyTasks = this.getDailyTasks.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.reset = this.reset.bind(this);
        this.newTask = this.newTask.bind(this);
        this.updateList = this.updateList.bind(this);
    }

    handleInputChange(event) {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    }

    handleSearch() {
        const { selectGroup, selectType, selectRank, originalDailyTasks, nameSearch } = this.state;

        const filtered = originalDailyTasks.filter(task => {
            const groupOk = !selectGroup || (task.group && task.group.toLowerCase().includes(selectGroup.toLowerCase()));
            const typeOk = !selectType || (task.type && task.type.toLowerCase().includes(selectType.toLowerCase()));
            const rankOk = !selectRank || (task.rank && task.rank.toLowerCase().includes(selectRank.toLowerCase()));
            const nameOk = !nameSearch || (task.name && task.name.toLowerCase().includes(nameSearch.toLowerCase()));
            return groupOk && typeOk && rankOk && nameOk;
        });
        this.setState({ dailyTasks: filtered });
    }

    componentDidMount() {
        this.getDailyTasks();

        // Khi modal đóng, dọn dailyTask để click "Thêm mới" lần sau lại trigger
        // componentDidUpdate trong modal con (so sánh prev vs cur).
        $("#modalUpdateDailyTask").on("hidden.bs.modal", function () {
            this.setState({ dailyTask: null });
        }.bind(this));
    }

    getDailyTasks() {
        this.setState({ loading: true });

        listDailyTasks()
            .then(body => {
                if (body && body.status === "OK") {
                    const tasks = body.data || [];
                    this.setState({
                        dailyTasks: tasks,
                        originalDailyTasks: tasks,
                        loading: false,
                    });
                } else {
                    this.setState({ loading: false });
                    toast.error((body && body.message) || "Không tải được danh sách nhiệm vụ");
                }
            })
            .catch(error => {
                console.error('Lỗi khi lấy danh sách nhiệm vụ:', error);
                this.setState({ loading: false });
                toast.error("Lỗi server khi tải danh sách nhiệm vụ");
            });
    }

    newTask() {
        this.setState({ dailyTask: { ...EMPTY_TASK }, register: true });
    }

    reset() {
        // Bug cũ: set các key không tồn tại (`show`, `type`, `tag`) thay vì
        // selectGroup/selectType/selectRank → filter cũ không thực sự bị xóa.
        this.setState({
            nameSearch: "",
            selectGroup: "",
            selectType: "",
            selectRank: "",
            dailyTasks: this.state.originalDailyTasks,
        });
    }

    updateList(newDailyTask) {
        if (!newDailyTask) return;
        const dailyTasks = [...this.state.dailyTasks];
        const idx = dailyTasks.findIndex(t => t.id === newDailyTask.id);
        if (idx !== -1) {
            dailyTasks[idx] = newDailyTask;
        } else {
            dailyTasks.unshift(newDailyTask);
        }
        // Cập nhật cả nguồn gốc để filter sau đó không bị mất task mới
        const originalDailyTasks = [...this.state.originalDailyTasks];
        const oIdx = originalDailyTasks.findIndex(t => t.id === newDailyTask.id);
        if (oIdx !== -1) {
            originalDailyTasks[oIdx] = newDailyTask;
        } else {
            originalDailyTasks.unshift(newDailyTask);
        }
        this.setState({ dailyTasks, originalDailyTasks });
    }

    formatTime(seconds) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;
        return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }

    render() {
        const { dailyTasks, selectGroup, selectType, selectRank, nameSearch, register } = this.state;

        return (
            <>
                <ModalUpdateDailyTask
                    resetList={this.updateList}
                    dailyTask={this.state.dailyTask}
                    register={register}
                />
                <div id="content">
                    <div className="container-fluid">
                        <h1 className="text-center">Quản lý nhiệm vụ hằng ngày</h1>
                        <div>
                            <button
                                className="btn btn-red"
                                onClick={this.newTask}
                                data-toggle="modal"
                                data-target="#modalUpdateDailyTask"
                            >Thêm mới nhiệm vụ</button>
                        </div>
                        <div className="input-group mb-3">
                            <input
                                name="nameSearch"
                                value={nameSearch}
                                onChange={this.handleInputChange}
                                onKeyPress={(event) => {
                                    if (event.key === "Enter") this.handleSearch();
                                }}
                                type="text"
                                className="form-control col-md-2 col-sm-6"
                                placeholder="Nhập tên nhiệm vụ"
                                aria-label="Recipient's username"
                                aria-describedby="button-addon2" />
                            <select
                                name="selectGroup"
                                value={selectGroup}
                                className="form-control col-md-1 col-3"
                                onChange={this.handleInputChange}>
                                <option value="">Id nhiệm vụ</option>
                                {DAILY_TASK_GROUPS.map(g => (
                                    <option key={g} value={g}>{g}</option>
                                ))}
                            </select>
                            <select
                                name="selectType"
                                value={selectType}
                                className="form-control col-md-1 col-3"
                                onChange={this.handleInputChange}>
                                <option value="">Type</option>
                                {TASK_TYPES.map(t => (
                                    <option key={t.value} value={t.value}>{t.label}</option>
                                ))}
                            </select>
                            <select
                                name="selectRank"
                                value={selectRank}
                                className="form-control col-md-1 col-3"
                                onChange={this.handleInputChange}>
                                <option value="">Rank</option>
                                {TASK_RANKS.map(r => (
                                    <option key={r.value} value={r.value}>{r.label}</option>
                                ))}
                            </select>

                            <div className="input-group-append">
                                <button
                                    className="btn btn-outline-success"
                                    type="button"
                                    onClick={this.handleSearch}
                                    style={{ height: '38px' }}>
                                    <i className="fa fa-search"></i>
                                </button>
                                <button
                                    className="btn btn-outline-danger"
                                    type="button"
                                    onClick={this.reset}
                                    style={{ height: '38px' }}>
                                    <i className="fas fa-sync"></i>
                                </button>
                            </div>
                        </div>
                        <table className="table table-hover">
                            <thead>
                                <tr className="align-middle">
                                    <th className="align-middle" scope="col">Id</th>
                                    <th className="align-middle" scope="col">Id nhiệm vụ</th>
                                    <th className="align-middle" scope="col">Icon</th>
                                    <th className="align-middle" scope="col">Tên nhiệm vụ</th>
                                    <th className="align-middle" scope="col">Min level</th>
                                    <th className="align-middle" scope="col">Số lượng</th>
                                    <th className="align-middle" scope="col">Icoin được tặng</th>
                                    <th className="align-middle" scope="col">Thời gian hoàn thành</th>
                                    <th className="align-middle" scope="col">Type ( loại tân thủ/ nhiệm vụ user)</th>
                                    <th className="align-middle" scope="col">Độ khó</th>
                                    <th className="align-middle" scope="col">Id màn hình đi tới</th>
                                    <th className="align-middle" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {dailyTasks.map((dailyTask) => {
                                    const rowClass = dailyTask.type === 'NEW_USER' ? 'new-user-row' : '';
                                    return (
                                        <tr key={dailyTask.id} className={rowClass}>
                                            <td>{dailyTask.id}</td>
                                            <td>{dailyTask.group}</td>
                                            <td><img className="gift-image" alt="" src={dailyTask.image} /></td>
                                            <td>{dailyTask.name}</td>
                                            <td>{dailyTask.minLevel}</td>
                                            <td>{dailyTask.requestNumber}</td>
                                            <td>{dailyTask.bonus}</td>
                                            <td>
                                                {dailyTask.averageTime ? this.formatTime(dailyTask.averageTime) : '-'}
                                            </td>
                                            <td>{dailyTask.type}</td>
                                            <td>{dailyTask.rank}</td>
                                            <td>{dailyTask.screenId}</td>
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        this.setState({
                                                            dailyTask: dailyTask,
                                                            register: false,
                                                        });
                                                    }}
                                                    className="btn btn-red"
                                                    data-toggle="modal"
                                                    data-target="#modalUpdateDailyTask"
                                                >Sửa</button>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        );
    }
}
